import { useEffect, useRef, useState } from "react";
import { CABINET_IMAGE_URL, CABINET_NAME } from "../_data/constants";
import { IconUserSilhouette } from "./icons";
import { CabinetSheet } from "./cabinet-sheet";

export function CabinetHero({ title }: { title: string }) {
  const [open, setOpen] = useState(false);
  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    let frame: number | null = null;

    const update = () => {
      const img = imgRef.current;
      if (img) {
        const y = window.scrollY * 0.4;
        img.style.transform = `translate3d(0, ${y}px, 0) scale(1.18)`;
      }
      frame = null;
    };

    const onScroll = () => {
      if (frame !== null) return;
      frame = requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (frame !== null) cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <header className="relative -mt-[env(safe-area-inset-top)] w-full">
      <div className="relative w-full overflow-hidden h-[calc(14rem+env(safe-area-inset-top))] sm:h-[calc(16rem+env(safe-area-inset-top))] lg:h-[calc(12rem+env(safe-area-inset-top))]">
        <img
          ref={imgRef}
          src={CABINET_IMAGE_URL}
          alt={`Cabinet ${CABINET_NAME}`}
          referrerPolicy="no-referrer"
          className="absolute inset-0 size-full object-cover will-change-transform"
          style={{
            transform: "translate3d(0, 0, 0) scale(1.05)",
            transformOrigin: "center top",
            backfaceVisibility: "hidden",
          }}
        />
        <div
          aria-hidden
          className="absolute inset-x-0 bottom-0 h-1/2 bg-linear-to-b from-transparent via-[var(--bg-canvas)]/40 to-[var(--bg-canvas)]"
        />
        <div className="absolute inset-x-0 top-[calc(env(safe-area-inset-top)+0.75rem)] mx-auto flex w-full max-w-md items-center justify-end px-4 sm:max-w-xl sm:px-5 lg:max-w-3xl lg:px-8 xl:max-w-4xl">
          <button
            type="button"
            onClick={() => setOpen(true)}
            aria-label="Changer de cabinet"
            className="inline-flex size-12 items-center justify-center rounded-full bg-[var(--overlay-frost)] shadow-md ring-1 ring-[var(--border-1)] backdrop-blur-md transition active:scale-95"
          >
            <IconUserSilhouette
              width={26}
              height={26}
              className="text-[var(--text-2)]"
            />
          </button>
        </div>
        <div className="absolute inset-x-0 bottom-0">
          <div className="mx-auto w-full max-w-md px-4 pb-3 sm:max-w-xl sm:px-5 lg:max-w-3xl lg:px-8 xl:max-w-4xl">
            <h1 className="text-[40px] font-extrabold leading-none tracking-tight text-[var(--text-1)] sm:text-[44px] lg:text-[32px]">
              {title}
            </h1>
          </div>
        </div>
      </div>
      <CabinetSheet open={open} onClose={() => setOpen(false)} />
    </header>
  );
}
